import styles from "./App.module.css";
import { Solid } from "./Solid";
import PulseCore from "./PulseCore";
import ActivityFeed from "./ActivityFeed";

/* ═══════════════════════════════════════════
   SOLID PROTOCOL — solidcapa.com
   Terra didn't die. It was rebuilt.
   ═══════════════════════════════════════════ */

export default function App() {
  return (
    <div className={styles.page}>
      {/* ─── Ambient Background ─── */}
      <div className={styles.ambientOrb1} aria-hidden="true" />
      <div className={styles.ambientOrb2} aria-hidden="true" />
      <div className={styles.ambientOrb3} aria-hidden="true" />
      <div className={styles.gridOverlay} aria-hidden="true" />
      <div className={styles.noise} aria-hidden="true" />

      {/* ─── Header ─── */}
      <header className={styles.header}>
        <a href="#top" className={styles.headerBrand} aria-label="Solid Protocol">
          <svg width="22" height="22" viewBox="0 0 500 500" aria-hidden="true">
            <defs>
              <linearGradient id="hdGrad" x1="0" y1="1" x2="1" y2="0">
                <stop stopColor="#6086FF" />
                <stop offset="1" stopColor="#FF47C2" />
              </linearGradient>
            </defs>
            <path
              d="M 357.608 141.488 C 339.631 145.285 323.829 155.109 308.786 165.766 C 295.622 175.068 271.87 188.688 249.428 188.688 C 226.569 188.688 205.963 181.096 192.844 167.894 C 189.528 164.557 185.043 162.7 180.351 162.679 C 175.637 162.679 171.153 164.536 167.837 167.852 C 164.521 171.168 162.664 175.652 162.664 180.345 C 162.664 185.037 164.521 189.522 167.837 192.838 C 194.95 219.952 195.764 276.14 169.547 304.505 C 155.322 317.812 136.76 325.007 117.238 324.757 C 97.508 324.507 78.945 316.686 64.992 302.732 C 35.668 273.407 35.668 225.687 64.992 196.342 L 196.348 64.986 C 225.672 35.662 273.392 35.662 302.741 64.986 C 309.642 71.89 320.824 71.89 327.707 64.986 C 334.608 58.083 334.608 46.903 327.707 40.021 C 306.83 19.143 279.066 7.651 249.533 7.651 C 220 7.651 192.239 19.143 171.361 40.021 L 40.006 171.376 C 19.128 192.254 7.615 220.015 7.636 249.548 C 7.636 279.081 19.128 306.841 40.006 327.718 C 60.507 348.221 87.789 359.733 116.779 360.088 C 125.164 360.193 133.444 359.359 141.473 357.648 C 159.452 353.852 175.262 344.029 190.299 333.371 C 203.46 324.069 227.216 310.45 249.658 310.45 C 272.517 310.45 293.124 318.042 306.244 331.243 C 309.555 334.581 314.045 336.437 318.736 336.457 C 323.453 336.457 327.934 334.601 331.254 331.285 C 334.564 327.969 336.425 323.484 336.425 318.792 C 336.425 314.099 334.564 309.615 331.254 306.299 C 304.139 279.185 303.318 222.997 329.541 194.631 C 343.763 181.325 362.325 174.13 381.849 174.38 C 401.582 174.63 420.144 182.452 434.094 196.405 C 463.419 225.729 463.419 273.449 434.094 302.795 L 302.741 434.151 C 273.413 463.475 225.693 463.475 196.348 434.151 C 189.444 427.247 178.265 427.247 171.382 434.151 C 164.5 441.054 164.479 452.234 171.382 459.116 C 192.26 479.994 220.021 491.486 249.554 491.486 C 279.087 491.486 306.847 479.994 327.724 459.116 L 459.078 327.76 C 479.955 306.883 491.468 279.122 491.451 249.589 C 491.451 220.057 479.955 192.296 459.078 171.418 C 438.576 150.916 411.295 139.403 382.303 139.049 C 373.926 138.945 365.644 139.779 357.608 141.488 Z"
              fill="url(#hdGrad)"
            />
          </svg>
          <span>Solid</span>
        </a>
        <nav className={styles.headerNav} aria-label="Primary">
          <a href="#protocol">Protocol</a>
          <a href="/learn/">Learn</a>
          <a href="/whitepaper-v2.pdf" target="_blank" rel="noopener noreferrer">Whitepaper</a>
        </nav>
        <a href="https://app.solidcapa.com" className={styles.launchBtn} aria-label="Launch Solid Web App">
          <span className={styles.launchBtnGlow} />
          LAUNCH APP
        </a>
      </header>

      {/* ─── Hero ─── */}
      <main className={styles.hero} id="top">
        <div className={styles.heroGrid}>
          <div className={styles.heroContent}>
            <div className={styles.badge}>
              <span className={styles.badgeDot} />
              Live on Terra2 &middot; 4 collaterals &middot; CAPA governance
            </div>
            <h1 className={styles.title}>
              <span>Solid</span>
              <Solid />
            </h1>
            <p className={styles.heroKicker}>
              Terra didn&apos;t die.<br />
              <em>It was rebuilt.</em>
            </p>
            <p className={styles.subTitle}>
              A decentralized, overcollateralized lending protocol on Terra2.
              Deposit collateral. Borrow SOLID. No custody. No admin keys
              on the core. No permission needed.
            </p>
            <div className={styles.heroCtas}>
              <a href="https://app.solidcapa.com" className={styles.buttonPrimary} aria-label="Launch Solid Web App">
                <span className={styles.btnShine} />
                ENTER THE PROTOCOL
              </a>
              <a href="/whitepaper-v2.pdf" target="_blank" rel="noopener noreferrer" className={styles.buttonSecondary} aria-label="Read Solid Whitepaper">
                READ THE WHITEPAPER
              </a>
            </div>
            <div className={styles.heroTrust}>
              <span className={styles.heroTrustItem}>
                <span className={styles.checkDot} /> Fully on-chain
              </span>
              <span className={styles.heroTrustItem}>
                <span className={styles.checkDot} /> Non-custodial
              </span>
              <span className={styles.heroTrustItem}>
                <span className={styles.checkDot} /> Built on Terra2
              </span>
            </div>
          </div>

          <div className={styles.heroArt}>
            <PulseCore size={420} />
            <div className={styles.heroArtLabel}>
              <span className={styles.heroArtLabelTop}>Solid Core</span>
              <span className={styles.heroArtLabelBottom}>The pulse of Terra2</span>
            </div>
          </div>
        </div>
      </main>

      {/* ─── Live Stats Ticker ─── */}
      <section className={styles.statsTicker}>
        <div className={styles.statsInner}>
          <div className={styles.stat}>
            <span className={styles.statLabel}>TVL</span>
            <span className={styles.statValue}>$87.3K</span>
          </div>
          <div className={styles.statDivider} />
          <div className={styles.stat}>
            <span className={styles.statLabel}>Collateralization</span>
            <span className={styles.statValue}>118%+</span>
          </div>
          <div className={styles.statDivider} />
          <div className={styles.stat}>
            <span className={styles.statLabel}>Collaterals</span>
            <span className={styles.statValue}>4 Assets</span>
          </div>
          <div className={styles.statDivider} />
          <div className={styles.stat}>
            <span className={styles.statLabel}>CAPA Holders</span>
            <span className={styles.statValue}>4,891+</span>
          </div>
          <div className={styles.statDivider} />
          <div className={styles.stat}>
            <span className={styles.statLabel}>Core admin keys</span>
            <span className={styles.statValue}>0</span>
          </div>
        </div>
      </section>

      {/* ─── Manifesto ─── */}
      <section className={styles.manifesto} id="protocol">
        <div className={styles.manifestoInner}>
          <span className={styles.manifestoKicker}>The thesis</span>
          <h2 className={styles.manifestoTitle}>
            Permissionless money,<br />
            <em>rebuilt on Terra2.</em>
          </h2>
          <p className={styles.manifestoBody}>
            Solid is a permissionless experimental lending protocol on Terra2.
            You deposit collateral, you borrow SOLID. There is no foundation
            with a kill switch and no centralized reserve. SOLID is a
            borrowable unit soft-referenced to USD through overcollateralized
            debt — not a licensed stablecoin.
          </p>
          <div className={styles.manifestoPillars}>
            <div className={styles.pillar}>
              <div className={styles.pillarNum}>01</div>
              <h3 className={styles.pillarTitle}>Overcollateralized by design</h3>
              <p className={styles.pillarDesc}>
                Every SOLID in circulation is backed by over-collateralized
                Terra2 positions. The reference price holds because the
                collateral holds.
              </p>
            </div>
            <div className={styles.pillar}>
              <div className={styles.pillarNum}>02</div>
              <h3 className={styles.pillarTitle}>Owned by its users</h3>
              <p className={styles.pillarDesc}>
                CAPA token is live governance. Stake, vote, steer the protocol. No team
                multisig overriding you. Your deposit stays yours.
              </p>
            </div>
            <div className={styles.pillar}>
              <div className={styles.pillarNum}>03</div>
              <h3 className={styles.pillarTitle}>Terra-native, forever</h3>
              <p className={styles.pillarDesc}>
                Built where LUNA was reborn. Tight integrations with Astroport, Eris,
                and the validator set that keeps Terra2 alive.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ─── Live Activity Feed ─── */}
      <ActivityFeed />

      {/* ─── Features ─── */}
      <section className={styles.features}>
        <span className={styles.sectionKicker}>Under the hood</span>
        <h2 className={styles.sectionTitle}>Everything it takes to build trust.</h2>
        <p className={styles.sectionSubtitle}>Six things we ship so you don&apos;t have to think about them.</p>
        <div className={styles.featuresGrid}>
          <div className={styles.featureCard}>
            <div className={styles.featureIconWrap}><div className={styles.featureIcon}>🏛</div></div>
            <h3 className={styles.featureTitle}>4 Collateral Types</h3>
            <p className={styles.featureDesc}>LUNA, ampLUNA, bLUNA, ATOM. All live. All overcollateralized.</p>
          </div>
          <div className={styles.featureCard}>
            <div className={styles.featureIconWrap}><div className={styles.featureIcon}>🔭</div></div>
            <h3 className={styles.featureTitle}>Live Oracle</h3>
            <p className={styles.featureDesc}>Prices from Astroport TWAPs and validator feeds. No stale data, no admin override.</p>
          </div>
          <div className={styles.featureCard}>
            <div className={styles.featureIconWrap}><div className={styles.featureIcon}>📊</div></div>
            <h3 className={styles.featureTitle}>Position Simulator</h3>
            <p className={styles.featureDesc}>Model your LTV, liquidation price, and yield before a single tx signs.</p>
          </div>
          <div className={styles.featureCard}>
            <div className={styles.featureIconWrap}><div className={styles.featureIcon}>🗳</div></div>
            <h3 className={styles.featureTitle}>CAPA Governance</h3>
            <p className={styles.featureDesc}>Stake CAPA, vote on every protocol parameter, earn staking rewards.</p>
          </div>
          <div className={styles.featureCard}>
            <div className={styles.featureIconWrap}><div className={styles.featureIcon}>⚡</div></div>
            <h3 className={styles.featureTitle}>Open Liquidations</h3>
            <p className={styles.featureDesc}>Any wallet can place liquidation bids. Discount-based, permissionless, instant.</p>
          </div>
          <div className={styles.featureCard}>
            <div className={styles.featureIconWrap}><div className={styles.featureIcon}>🔮</div></div>
            <h3 className={styles.featureTitle}>Crystals + Seasons</h3>
            <p className={styles.featureDesc}>Your on-chain story, crystallized. Mint once. Evolve across every season.</p>
          </div>
        </div>
      </section>

      {/* ─── Comparison ─── */}
      <section className={styles.compare}>
        <span className={styles.sectionKicker}>Why Solid</span>
        <h2 className={styles.sectionTitle}>Not the old playbook.</h2>
        <p className={styles.sectionSubtitle}>What DeFi lending should have been from day one.</p>
        <div className={styles.compareTable}>
          <div className={`${styles.compareRow} ${styles.compareHead}`}>
            <div />
            <div>Solid</div>
            <div>Anchor &middot; 2022</div>
            <div>Aave / Compound</div>
          </div>
          <div className={styles.compareRow}>
            <div className={styles.compareLabel}>Peg backing</div>
            <div className={styles.compareYes}>118%+ hard collateral</div>
            <div className={styles.compareNo}>Algorithmic / subsidized</div>
            <div className={styles.compareMid}>Algorithmic / external</div>
          </div>
          <div className={styles.compareRow}>
            <div className={styles.compareLabel}>Core contract admin keys</div>
            <div className={styles.compareYes}>None on legacy core</div>
            <div className={styles.compareNo}>Foundation multisig</div>
            <div className={styles.compareMid}>Timelock + multisig</div>
          </div>
          <div className={styles.compareRow}>
            <div className={styles.compareLabel}>Yield source</div>
            <div className={styles.compareYes}>Real trading fees + PoS</div>
            <div className={styles.compareNo}>Treasury subsidy</div>
            <div className={styles.compareMid}>Borrow-demand spread</div>
          </div>
          <div className={styles.compareRow}>
            <div className={styles.compareLabel}>Chain</div>
            <div className={styles.compareYes}>Terra2 native</div>
            <div className={styles.compareNo}>Terra Classic (dead)</div>
            <div className={styles.compareMid}>EVM (gas-heavy)</div>
          </div>
          <div className={styles.compareRow}>
            <div className={styles.compareLabel}>Collectible layer</div>
            <div className={styles.compareYes}>CAPA Crystals + Relics</div>
            <div className={styles.compareNo}>None</div>
            <div className={styles.compareNo}>None</div>
          </div>
        </div>
      </section>

      {/* ─── Social proof ─── */}
      <section className={styles.proof}>
        <div className={styles.proofGrid}>
          <div className={styles.proofCard}>
            <div className={styles.proofNum}>4,891+</div>
            <div className={styles.proofLabel}>CAPA holders</div>
          </div>
          <div className={styles.proofCard}>
            <div className={styles.proofNum}>100%</div>
            <div className={styles.proofLabel}>Uptime since mainnet</div>
          </div>
          <div className={styles.proofCard}>
            <div className={styles.proofNum}>$87.3K</div>
            <div className={styles.proofLabel}>Value locked</div>
          </div>
          <div className={styles.proofCard}>
            <div className={styles.proofNum}>0</div>
            <div className={styles.proofLabel}>Core admin keys</div>
          </div>
        </div>
      </section>

      {/* ─── Final CTA ─── */}
      <section className={styles.ctaBanner}>
        <div className={styles.ctaGlow} aria-hidden="true" />
        <span className={styles.sectionKicker}>Your move</span>
        <h2 className={styles.ctaTitle}>
          Permissionless money,<br /><em>rebuilt on Terra2.</em>
        </h2>
        <p className={styles.ctaDesc}>
          Deposit collateral in minutes. Borrow SOLID against it. Stake CAPA
          to steer the protocol. No sign-up. No middleman. No kill switch.
        </p>
        <div className={styles.ctaButtons}>
          <a href="https://app.solidcapa.com" className={styles.ctaButton}>
            <span className={styles.btnShine} />
            LAUNCH APP
          </a>
          <a href="/whitepaper-v2.pdf" target="_blank" rel="noopener noreferrer" className={styles.buttonGhost}>
            Read the whitepaper
          </a>
        </div>
      </section>

      {/* ─── Footer ─── */}
      <footer className={styles.footer}>
        <div className={styles.footerInner}>
          <div className={styles.footerBrand}>
            <div className={styles.footerLogo}>
              <svg width="24" height="24" viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <defs>
                  <linearGradient id="footerGrad" x1="0" y1="1" x2="1" y2="0">
                    <stop stopColor="#6086FF" />
                    <stop offset="1" stopColor="#FF47C2" />
                  </linearGradient>
                </defs>
                <path d="M 357.608 141.488 C 339.631 145.285 323.829 155.109 308.786 165.766 C 295.622 175.068 271.87 188.688 249.428 188.688 C 226.569 188.688 205.963 181.096 192.844 167.894 C 189.528 164.557 185.043 162.7 180.351 162.679 C 175.637 162.679 171.153 164.536 167.837 167.852 C 164.521 171.168 162.664 175.652 162.664 180.345 C 162.664 185.037 164.521 189.522 167.837 192.838 C 194.95 219.952 195.764 276.14 169.547 304.505 C 155.322 317.812 136.76 325.007 117.238 324.757 C 97.508 324.507 78.945 316.686 64.992 302.732 C 35.668 273.407 35.668 225.687 64.992 196.342 L 196.348 64.986 C 225.672 35.662 273.392 35.662 302.741 64.986 C 309.642 71.89 320.824 71.89 327.707 64.986 C 334.608 58.083 334.608 46.903 327.707 40.021 C 306.83 19.143 279.066 7.651 249.533 7.651 C 220 7.651 192.239 19.143 171.361 40.021 L 40.006 171.376 C 19.128 192.254 7.615 220.015 7.636 249.548 C 7.636 279.081 19.128 306.841 40.006 327.718 C 60.507 348.221 87.789 359.733 116.779 360.088 C 125.164 360.193 133.444 359.359 141.473 357.648 C 159.452 353.852 175.262 344.029 190.299 333.371 C 203.46 324.069 227.216 310.45 249.658 310.45 C 272.517 310.45 293.124 318.042 306.244 331.243 C 309.555 334.581 314.045 336.437 318.736 336.457 C 323.453 336.457 327.934 334.601 331.254 331.285 C 334.564 327.969 336.425 323.484 336.425 318.792 C 336.425 314.099 334.564 309.615 331.254 306.299 C 304.139 279.185 303.318 222.997 329.541 194.631 C 343.763 181.325 362.325 174.13 381.849 174.38 C 401.582 174.63 420.144 182.452 434.094 196.405 C 463.419 225.729 463.419 273.449 434.094 302.795 L 302.741 434.151 C 273.413 463.475 225.693 463.475 196.348 434.151 C 189.444 427.247 178.265 427.247 171.382 434.151 C 164.5 441.054 164.479 452.234 171.382 459.116 C 192.26 479.994 220.021 491.486 249.554 491.486 C 279.087 491.486 306.847 479.994 327.724 459.116 L 459.078 327.76 C 479.955 306.883 491.468 279.122 491.451 249.589 C 491.451 220.057 479.955 192.296 459.078 171.418 C 438.576 150.916 411.295 139.403 382.303 139.049 C 373.926 138.945 365.644 139.779 357.608 141.488 Z" fill="url(#footerGrad)" />
              </svg>
              <span>Solid</span>
            </div>
            <p className={styles.footerTagline}>
              A decentralized lending protocol on Terra2.<br />
              Open. Overcollateralized. Owned by its users.
            </p>
          </div>

          <nav className={styles.footerLinks} aria-label="Footer navigation">
            <div className={styles.footerCol}>
              <h3 className={styles.footerColTitle}>Protocol</h3>
              <a href="https://app.solidcapa.com">Launch App</a>
              <a href="https://app.solidcapa.com/dashboard">Dashboard</a>
              <a href="https://app.solidcapa.com/gov">Governance</a>
              <a href="/learn/">Learn</a>
              <a href="/whitepaper-v2.pdf" target="_blank" rel="noopener noreferrer">Whitepaper</a>
            </div>
            <div className={styles.footerCol}>
              <h3 className={styles.footerColTitle}>Community</h3>
              <a href="https://twitter.com/solid_capa" target="_blank" rel="noopener noreferrer">X (Twitter)</a>
              <a href="https://t.me/SolidTG" target="_blank" rel="noopener noreferrer">Telegram</a>
              <a href="https://discord.gg/EXxBfhEz28" target="_blank" rel="noopener noreferrer">Discord</a>
            </div>
          </nav>
        </div>

        <div className={styles.footerBottom}>
          <span className={styles.footerCopy}>&copy; {new Date().getFullYear()} Solid Protocol &middot; Not financial advice</span>
          <div className={styles.footerSocials}>
            <a href="https://twitter.com/solid_capa" target="_blank" rel="noopener noreferrer" aria-label="Follow Solid on X">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
            </a>
            <a href="https://t.me/SolidTG" target="_blank" rel="noopener noreferrer" aria-label="Join Solid on Telegram">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>
            </a>
            <a href="https://discord.gg/EXxBfhEz28" target="_blank" rel="noopener noreferrer" aria-label="Join Solid on Discord">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.946 2.4189-2.1568 2.4189z"/></svg>
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
